import {types} from 'mobx-state-tree';
import MessageFormat from '../format';

const InflightTextMessageModel = types.model({
  id: types.null,
  cid: types.string,
  format: MessageFormat,
  senderId: types.number,
  senderName: types.string,
  senderAvatar: types.string,
  createdAt: types.number
});

export type InflightTextMessage = typeof InflightTextMessageModel.Type;

export default InflightTextMessageModel;



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/message/branches/inflightMessageModel.ts